<ng-container class="flex flex-col"
  *ngIf="this?.serviceLaneFacade?.oemDashboardData$ | async as nissanDashboardData; else dashboardLoading">
  <div *ngIf="nissanDashboardData?.error === null">
    <div style="
        width: 100%;
        background: linear-gradient(0deg, rgba(255, 255, 255, 0?.7978260869565217) 0%, rgba(255, 255, 255, 1) 33%);
        z-index: 1;
        height: 56px;
        margin-top: 24px;
      " fxLayoutAlign="space-between center">
      <h2>Vehicle Information</h2>
      <button mat-icon-button class="mr-1" (click)="toggleCollapse(vehicleInfoUi)">
        <mat-icon>{{ vehicleInfoUi?.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }} </mat-icon>
      </button>
    </div>
    <ng-container *ngIf="!vehicleInfoUi?.collapsed">
      <div class="mb-5 py-0 px-4" id="vehicleInfoContainer">
        <div class="flex flex-row" *ngIf="
            nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.VehicleServiceHistoryVehicleLineItem?.Vehicle
          ">
          <div class="w-1/2">
            <span class="pr-1">Vehicle Description:</span>
            <span>{{
              nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.VehicleServiceHistoryVehicleLineItem?.Vehicle
              ?.ModelYear?._text
              }}
              {{
              nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.VehicleServiceHistoryVehicleLineItem?.Vehicle
              ?.Model?._text
              }}
              {{
              nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.VehicleServiceHistoryVehicleLineItem?.Vehicle
              ?.ModelDescription?._text
              }}</span>
          </div>
          <div class="w-1/2">
            <span class="pr-1">Model Make:</span>
            <span>{{
              nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.VehicleServiceHistoryVehicleLineItem?.Vehicle
              ?.MakeString?._text
              }}</span>
          </div>
        </div>

        <div class="flex flex-row" *ngIf="
            nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.VehicleServiceHistoryVehicleLineItem?.Vehicle
          ">
          <div class="w-1/2">
            <span class="pr-1">Model Line/Trim Code:</span>
            <span>{{
              (nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.VehicleServiceHistoryVehicleLineItem?.Vehicle)[
              'star:TrimCode'
              ]?._text
              }}</span>
          </div>
          <div class="w-1/2">
            <span class="pr-1">Interior Color:</span>
            <span>{{
              nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.VehicleServiceHistoryVehicleLineItem?.Vehicle
              ?.ColorGroup?.ManufacturerColorCode?._text
              }},
              {{
              nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.VehicleServiceHistoryVehicleLineItem?.Vehicle
              ?.ColorGroup?.ColorDescription?._text
              }}</span>
          </div>
        </div>

        <div class="flex flex-row" *ngIf="
            nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.VehicleServiceHistoryVehicleLineItem?.Vehicle
          ">
          <div class="w-1/2">
            <span class="pr-1">Transmission:</span>
            <span>{{
              nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.VehicleServiceHistoryVehicleLineItem?.Vehicle
              ?.TransmissionGroup?.TransmissionCode?._text
              }}</span>
          </div>
          <div class="w-1/2">
            <span class="pr-1">Engine/Emissions:</span>
            <span></span>
          </div>
        </div>

        <div class="flex flex-row" *ngIf="
            nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.VehicleServiceHistoryVehicleLineItem?.Vehicle
          ">
          <div class="w-1/2">
            <span class="pr-1">Stock Group:</span>
            <span>{{
              nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.VehicleServiceHistoryVehicleLineItem?.Vehicle
              ?.VehicleStockString?._text
              }}</span>
          </div>
          <div class="w-1/2">
            <span class="pr-1">Stock Group/Number:</span>
            <span>{{
              nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.VehicleServiceHistoryVehicleLineItem?.Vehicle
              ?.VehicleStockString?._text
              }}</span>
          </div>
        </div>

        <div class="flex flex-row" *ngIf="
            nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.VehicleServiceHistoryVehicleLineItem?.Vehicle
          ">
          <div class="w-1/2">
            <span class="pr-1">Build Date:</span>
            <span>{{
              nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.VehicleServiceHistoryVehicleLineItem
              ?.VehicleBuildDate?._text | date: 'mediumDate'
              }}</span>
          </div>
          <div class="w-1/2">
            <span class="pr-1">Plant:</span>
            <span>{{
              nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.VehicleServiceHistoryVehicleLineItem
              ?.VehicleBuildPlantCodeDescription?._text
              }}</span>
          </div>
        </div>

        <div class="flex flex-row" *ngIf="
            nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.VehicleServiceHistoryVehicleLineItem?.Vehicle
          ">
          <div class="w-1/2">
            <span class="pr-1">Delivery/Sales/Retail Date:</span>
            <span>{{
              nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.VehicleServiceHistoryVehicleLineItem?.DeliveryDate
              ?._text | date: 'mediumDate'
              }}</span>
          </div>
          <div class="w-1/2"></div>
        </div>

        <div class="flex flex-row" *ngIf="
            nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.VehicleServiceHistoryVehicleLineItem?.Vehicle
          ">
          <div class="w-1/2">
            <span class="pr-1">In Service Mileage:</span>
            <span>{{
              nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.VehicleServiceHistoryVehicleLineItem?.InService
              ?.InServiceDistanceMeasure?._text
              }}</span>
          </div>
          <div class="w-1/2">
            <span class="pr-1">Foreign Vehicle:</span>
            <span></span>
          </div>
        </div>

        <div class="flex flex-row" *ngIf="
            nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.VehicleServiceHistoryVehicleLineItem?.Vehicle
          ">
          <div class="w-1/2">
            <span class="pr-1">Option Group:</span>
            <span></span>
          </div>
          <div class="w-1/2">
            <span class="pr-1">PDI Date:</span>
            <span>{{
              nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.VehicleServiceHistoryVehicleLineItem?.InService
              ?.PDIDate
              ? nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.VehicleServiceHistoryVehicleLineItem
              ?.InService?.PDIDate?._text
              : 'Unavailable'
              }}</span>
          </div>
        </div>

        <div class="flex flex-row" *ngIf="
            nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.VehicleServiceHistoryVehicleLineItem?.Vehicle
          ">
          <div class="w-1/2">
            <span class="pr-1">Selling Dealership:</span>
            <span>{{
              nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.DeliveryDealerParty?.SpecifiedOrganization
              ?.CompanyName?._text
              }}</span>
          </div>
          <div class="w-1/2">
            <span class="pr-1">Selling Dealership Code:</span>
            <span>{{
              nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.DeliveryDealerParty?.SpecifiedOrganization
              ?.CompanyCode?._text
              }}</span>
          </div>
        </div>

        <div class="flex flex-row" *ngIf="
            nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.VehicleServiceHistoryVehicleLineItem?.Vehicle
          ">
          <div class="w-1/2">
            <span class="pr-1">Selling Dealership Location/City:</span>
            <span>{{
              nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.DeliveryDealerParty?.SpecifiedOrganization
              ?.PostalAddress?.CityName?._text
              }}</span>
          </div>
          <div class="w-1/2">
            <span class="pr-1">Selling Dealership Location/State:</span>
            <span>{{
              nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.DeliveryDealerParty?.SpecifiedOrganization
              ?.PostalAddress?.CityName?._text
              }}</span>
          </div>
        </div>

        <div class="flex flex-row" *ngIf="
            nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.VehicleServiceHistoryVehicleLineItem?.Vehicle
          ">
          <div class="w-1/2">
            <span class="pr-1">Warranty Start:</span>
            <span></span>
          </div>
          <div class="w-1/2">
            <span class="pr-1">Warranty Expiration Date:</span>
            <span>{{
              (nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.Warranty)[1]?.WarrantyExpirationDate?._text
              | date: 'mediumDate'
              }}</span>
          </div>
        </div>

        <div class="flex flex-row" *ngIf="
            nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.VehicleServiceHistoryVehicleLineItem?.Vehicle
          ">
          <div class="w-1/2">
            <span class="pr-1">Warranty Expiration Mileage:</span>
            <span>{{
              (nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.Warranty)[1]?.FactoryExtWarrantyMileageDistance
              ?._text
              }}</span>
          </div>
          <div class="w-1/2"></div>
        </div>

        <span class="flex underline pt-2">Vehicle Options</span>
        <div class="flex flex-row" *ngIf="
            nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.VehicleServiceHistoryVehicleLineItem?.Vehicle
          ">
          <div class="w-1/2">
            <span class="pr-1">Code:</span>
            <span>{{
              nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.VehicleServiceHistoryVehicleLineItem?.Option
              ?.OptionTypeCode?._text
              }}</span>
          </div>
          <div class="w-1/2">
            <span class="pr-1">Description:</span>
            <span>{{
              nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.VehicleServiceHistoryVehicleLineItem?.Option
              ?.OptionShortDescription?._text
              }}</span>
          </div>
        </div>
      </div>
    </ng-container>

    <div style="
        width: 100%;
        background: linear-gradient(0deg, rgba(255, 255, 255, 0?.7978260869565217) 0%, rgba(255, 255, 255, 1) 33%);
        z-index: 1;
        height: 56px;
      " fxLayoutAlign="space-between center">
      <h2>Customer Information</h2>
      <button mat-icon-button style="margin-right: 4px;" (click)="toggleCollapse(customerInfoUi)">
        <mat-icon>{{ customerInfoUi?.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }} </mat-icon>
      </button>
    </div>
    <ng-container *ngIf="!customerInfoUi?.collapsed">
      <div class="mb-5 py-0 px-4" id="customerInfoContainer">
        <div *ngIf="isArray(
            nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.OwnerParty); else singleOwnerParty
          ">
          <div *ngFor="
              let owner of nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
                ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.OwnerParty
            ">
            <ng-container *ngIf="(owner?.SpecifiedPerson | json) !== '{}'">
              <div class="flex flex-col">
                <div class="flex flex-row pb-2">
                  <span class="pr-1">Customer Name:</span>
                  <span>{{
                    owner?.SpecifiedPerson?.Title?._text !== 'Unknown' ? owner?.SpecifiedPerson?.Title?._text : ''
                    }}
                    {{ owner?.SpecifiedPerson?.GivenName?._text }}
                    {{ owner?.SpecifiedPerson?.FamilyName?._text }}</span>
                </div>

                <span class="underline">Contact Info</span>
                <div class="pb-2"
                  *ngIf="isArray(owner?.SpecifiedPerson?.TelephoneCommunication); else singleContactInfo">
                  <div class="flex flex-row" *ngFor="let contactInfo of owner?.SpecifiedPerson?.TelephoneCommunication">
                    <span>{{ contactInfo?.UseCode?._text }}:</span>
                    <span>{{ contactInfo?.CountryNumberCode?._text.concat(contactInfo?.LocalNumber?._text) | phoneNumber
                      }}</span>
                  </div>
                </div>
                <ng-template #singleContactInfo> </ng-template>
                <div class="flex flex-col">
                  <span class="underline">Customer Address</span>
                  <span>{{ owner?.SpecifiedPerson?.ResidenceAddress?.LineOne?._text }} </span>
                  <span>{{ owner?.SpecifiedPerson?.ResidenceAddress?.CityName?._text }}
                    {{ (owner?.SpecifiedPerson?.ResidenceAddress)['star:StateOrProvinceCountrySub-DivisionID']?._text }}
                    {{ owner?.SpecifiedPerson?.ResidenceAddress?.Postcode?._text }}</span>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
        <ng-template #singleOwnerParty>
          <ng-container *ngIf="(nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
          ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.OwnerParty?.SpecifiedPerson | json) !== '{}'">
            <div class="flex flex-col">
              <div class="flex flex-row pb-2">
                <span class="pr-1">Customer Name:</span>
                <span>{{
                  nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
                  ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.OwnerParty?.SpecifiedPerson?.Title?._text !==
                  'Unknown' ? owner?.SpecifiedPerson?.Title?._text : ''
                  }}
                  {{ nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
                  ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.OwnerParty?.SpecifiedPerson?.GivenName?._text }}
                  {{ nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
                  ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.OwnerParty?.SpecifiedPerson?.FamilyName?._text
                  }}</span>
              </div>

              <span class="underline">Contact Info</span>
              <div class="pb-2"
                *ngIf="isArray(nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
                ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.OwnerParty?.SpecifiedPerson?.TelephoneCommunication); else singleContactInfo">
                <div class="flex flex-row"
                  *ngFor="let contactInfo of nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
                ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.OwnerParty?.SpecifiedPerson?.TelephoneCommunication">
                  <span>{{ contactInfo?.UseCode?._text }}:</span>
                  <span>{{ contactInfo?.CountryNumberCode?._text.concat(contactInfo?.LocalNumber?._text) | phoneNumber
                    }}</span>
                </div>
              </div>
              <ng-template #singleContactInfo> </ng-template>
              <div class="flex flex-col">
                <span class="underline">Customer Address</span>
                <span>{{ nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
                  ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.OwnerParty?.SpecifiedPerson?.ResidenceAddress?.LineOne?._text
                  }} </span>
                <span>{{ nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
                  ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.OwnerParty?.SpecifiedPerson?.ResidenceAddress?.CityName?._text
                  }}
                  {{ (nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
                  ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.OwnerParty?.SpecifiedPerson?.ResidenceAddress)['star:StateOrProvinceCountrySub-DivisionID']?._text
                  }}
                  {{ nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
                  ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.OwnerParty?.SpecifiedPerson?.ResidenceAddress?.Postcode?._text
                  }}</span>
              </div>
            </div>
          </ng-container>
        </ng-template>
      </div>
    </ng-container>

    <div style="
        width: 100%;
        background: linear-gradient(0deg, rgba(255, 255, 255, 0?.7978260869565217) 0%, rgba(255, 255, 255, 1) 33%);
        z-index: 1;
        height: 56px;
      " fxLayoutAlign="space-between center">
      <h2>General Warranty Information</h2>
      <button mat-icon-button style="margin-right: 4px;" (click)="toggleCollapse(warrantyUi)">
        <mat-icon>{{ warrantyUi?.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }} </mat-icon>
      </button>
    </div>
    <ng-container *ngIf="!warrantyUi?.collapsed">
      <div class="mb-5 py-0 px-4" id="warrantyContainer">
        <div *ngIf="
            nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.Warranty
          ">
          <div *ngFor="
              let warranty of nissanDashboardData?.dashboard?.ShowVehicleServiceHistory
                ?.ShowVehicleServiceHistoryDataArea?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.Warranty
            ">
            <ng-container
              *ngIf="warranty?.WarrantyTypeDescription && (warranty?.WarrantyTypeDescription | json) !== '{}'">
              <div class="w-1/2">
                <span class="pr-1">Warranty Description:</span>
                <span>{{ warranty?.WarrantyTypeDescription?._text }}</span>
              </div>
              <div class="flex flex-row">
                <div class="w-1/2">
                  <span class="pr-1">Warranty Expiration Date:</span>
                  <span>{{ warranty?.WarrantyExpirationDate?._text | date: 'mediumDate' }}</span>
                </div>
                <div class="w-1/2">
                  <span class="pr-1">Warranty Expiration Mileage:</span>
                  <span>{{ warranty?.FactoryExtWarrantyMileageDistance?._text | number | unitOfMeasure | async }}</span>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </ng-container>

    <div style="
        width: 100%;
        background: linear-gradient(0deg, rgba(255, 255, 255, 0?.7978260869565217) 0%, rgba(255, 255, 255, 1) 33%);
        z-index: 1;
        height: 56px;
      " fxLayoutAlign="space-between center">
      <h2>Outstanding Service/Recall Campaigns</h2>
      <button mat-icon-button style="margin-right: 4px;" (click)="toggleCollapse(outstandingServiceUi)">
        <mat-icon>{{ outstandingServiceUi?.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }} </mat-icon>
      </button>
    </div>
    <ng-container *ngIf="!outstandingServiceUi?.collapsed">
      <div class="mb-5 py-0 px-4" id="outstandingServiceContainer">
        <div *ngIf="
            nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
              ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.ServiceCampaign
          ">
          <div *ngIf="
              isArray(
                nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
                  ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.ServiceCampaign
              );
              else singleCampaign
            ">
            <ng-container *ngFor="
                let campaign of nissanDashboardData?.dashboard?.ShowVehicleServiceHistory
                  ?.ShowVehicleServiceHistoryDataArea?.VehicleServiceHistory?.VehicleServiceHistoryHeader
                  ?.ServiceCampaign
              ">
              <div class="w-1/2">
                <span class="pr-1">Campaign:</span>
                <span>{{ campaign?.CampaignNumberString?._text }} {{ campaign?.CampaignDescription?._text }}</span>
              </div>
            </ng-container>
          </div>
          <ng-template #singleCampaign>
            <div class="w-1/2">
              <span class="pr-1">Campaign:</span>
              <span>{{
                nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
                ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.ServiceCampaign?.CampaignNumberString?._text
                }}
                {{
                nissanDashboardData?.dashboard?.ShowVehicleServiceHistory?.ShowVehicleServiceHistoryDataArea
                ?.VehicleServiceHistory?.VehicleServiceHistoryHeader?.ServiceCampaign?.CampaignDescription?._text
                }}</span>
            </div>
          </ng-template>
        </div>
      </div>
    </ng-container>

    <div style="
        width: 100%;
        background: linear-gradient(0deg, rgba(255, 255, 255, 0?.7978260869565217) 0%, rgba(255, 255, 255, 1) 33%);
        z-index: 1;
        height: 56px;
      " fxLayoutAlign="space-between center">
      <h2>Extended Coverages</h2>
      <button mat-icon-button style="margin-right: 4px;" (click)="toggleCollapse(extendedCoveragesUi)">
        <mat-icon>{{ extendedCoveragesUi?.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }} </mat-icon>
      </button>
    </div>
    <ng-container *ngIf="!extendedCoveragesUi?.collapsed">
      <div class="mb-5 py-0 px-4" id="extendedCoveragesContainer">
        <!-- <div *ngIf="nissanDashboardData?.dashboard['star:ShowVehicleServiceHistory'][
        'star:ShowVehicleServiceHistoryDataArea'
      ]['star:VehicleServiceHistory']['star:VehicleServiceHistoryHeader']['star:ServiceCampaign']">
          <div>
            <ng-container>
              <div class="w-1/2">
                <span class="pr-1">Campaign:</span>
                <span>{{nissanDashboardData?.dashboard['star:ShowVehicleServiceHistory'][
                  'star:ShowVehicleServiceHistoryDataArea'
                  ]['star:VehicleServiceHistory']['star:VehicleServiceHistoryHeader']['star:ServiceCampaign']['star:CampaignNumberString']?._text}}
                  {{nissanDashboardData?.dashboard['star:ShowVehicleServiceHistory'][
                  'star:ShowVehicleServiceHistoryDataArea'
                  ]['star:VehicleServiceHistory']['star:VehicleServiceHistoryHeader']['star:ServiceCampaign']['star:CampaignDescription']?._text}}</span>
              </div>
            </ng-container>
          </div>
        </div> -->
      </div>
    </ng-container>

    <div style="
        width: 100%;
        background: linear-gradient(0deg, rgba(255, 255, 255, 0?.7978260869565217) 0%, rgba(255, 255, 255, 1) 33%);
        z-index: 1;
        height: 56px;
      " fxLayoutAlign="space-between center">
      <h2>National Service History</h2>
      <button mat-icon-button style="margin-right: 4px;" (click)="toggleCollapse(nationalServiceHistoryUi)">
        <mat-icon>{{ nationalServiceHistoryUi?.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }} </mat-icon>
      </button>
    </div>
    <ng-container *ngIf="!nationalServiceHistoryUi?.collapsed">
      <div class="mb-5 py-0 px-4" id="nationalServiceHistoryContainer">
        <!-- <div *ngIf="nissanDashboardData?.dashboard['star:ShowVehicleServiceHistory'][
        'star:ShowVehicleServiceHistoryDataArea'
      ]['star:VehicleServiceHistory']['star:VehicleServiceHistoryHeader']['star:ServiceCampaign']">
          <div>
            <ng-container>
              <div class="w-1/2">
                <span class="pr-1">Campaign:</span>
                <span>{{nissanDashboardData?.dashboard['star:ShowVehicleServiceHistory'][
                  'star:ShowVehicleServiceHistoryDataArea'
                  ]['star:VehicleServiceHistory']['star:VehicleServiceHistoryHeader']['star:ServiceCampaign']['star:CampaignNumberString']?._text}}
                  {{nissanDashboardData?.dashboard['star:ShowVehicleServiceHistory'][
                  'star:ShowVehicleServiceHistoryDataArea'
                  ]['star:VehicleServiceHistory']['star:VehicleServiceHistoryHeader']['star:ServiceCampaign']['star:CampaignDescription']?._text}}</span>
              </div>
            </ng-container>
          </div>
        </div> -->
      </div>
    </ng-container>

    <div style="
        width: 100%;
        background: linear-gradient(0deg, rgba(255, 255, 255, 0?.7978260869565217) 0%, rgba(255, 255, 255, 1) 33%);
        z-index: 1;
        height: 56px;
      " fxLayoutAlign="space-between center">
      <h2>Applicable TSB</h2>
      <button mat-icon-button style="margin-right: 4px;" (click)="toggleCollapse(appliableTSBUi)">
        <mat-icon>{{ appliableTSBUi?.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }} </mat-icon>
      </button>
    </div>
    <ng-container *ngIf="!appliableTSBUi?.collapsed">
      <div class="mb-5 py-0 px-4" id="nationalServiceHistoryContainer">
        <!-- <div *ngIf="nissanDashboardData?.dashboard['star:ShowVehicleServiceHistory'][
        'star:ShowVehicleServiceHistoryDataArea'
      ]['star:VehicleServiceHistory']['star:VehicleServiceHistoryHeader']['star:ServiceCampaign']">
          <div>
            <ng-container>
              <div class="w-1/2">
                <span class="pr-1">Campaign:</span>
                <span>{{nissanDashboardData?.dashboard['star:ShowVehicleServiceHistory'][
                  'star:ShowVehicleServiceHistoryDataArea'
                  ]['star:VehicleServiceHistory']['star:VehicleServiceHistoryHeader']['star:ServiceCampaign']['star:CampaignNumberString']?._text}}
                  {{nissanDashboardData?.dashboard['star:ShowVehicleServiceHistory'][
                  'star:ShowVehicleServiceHistoryDataArea'
                  ]['star:VehicleServiceHistory']['star:VehicleServiceHistoryHeader']['star:ServiceCampaign']['star:CampaignDescription']?._text}}</span>
              </div>
            </ng-container>
          </div>
        </div> -->
      </div>
    </ng-container>
  </div>
</ng-container>

<ng-template #dashboardLoading>
  <ng-container class="flex flex-col">
    <div style="
        width: 100%;
        position: sticky;
        top: 66px;
        background: linear-gradient(0deg, rgba(255, 255, 255, 0?.7978260869565217) 0%, rgba(255, 255, 255, 1) 33%);
        z-index: 1;
        height: 56px;
      ">
      <h2>Alerts</h2>
    </div>
    <div class="alerts-container py-0 px-4" id="alertsContainer">
      <div class="alert-block flex flex-col">
        <div class="flex flex-row mb-1" fxLayoutAlign="start center">
          <div class="animated-background h-6 w-6 my-1?.5 mr-0 ml-2 rounded-xl"></div>
          <span class="animated-background h-4 w-1/3 my-1?.5 mr-0 ml-2 rounded"></span>
        </div>
        <div fxLayoutAlign="start start" class="pl-8">
          <span class="animated-background h-4 w-1/5 my-1?.5 mr-0 ml-2 rounded"></span>
        </div>
      </div>
    </div>

    <div style="
        width: 100%;
        position: sticky;
        top: 66px;
        background: linear-gradient(0deg, rgba(255, 255, 255, 0?.7978260869565217) 0%, rgba(255, 255, 255, 1) 33%);
        z-index: 1;
        height: 56px;
      ">
      <h2>OnStar</h2>
    </div>
    <div class="flex flex-col alerts-container py-0 px-4" id="onStarContainer">
      <div class="flex flex-col alert-block">
        <span class="font-medium text-base mb-2">Status</span>

        <div fxLayout="row wrap">
          <div fxFlex="50" class="flex flex-row mb-1" fxLayoutAlign="start start">
            <div class="animated-background h-6 w-6 my-1?.5 mr-0 ml-2 rounded-xl"></div>
            <span class="animated-background h-4 w-2/5 mt-2?.5 mr-0 mb-1?.5 ml-2 rounded"></span>
          </div>
          <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
            <div class="animated-background h-6 w-6 my-1?.5 mr-0 ml-2 rounded-xl"></div>
            <span class="animated-background h-4 w-2/5 mt-2?.5 mr-0 mb-1?.5 ml-2 rounded"></span>
          </div>
          <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
            <div class="animated-background h-6 w-6 my-1?.5 mr-0 ml-2 rounded-xl"></div>
            <span class="animated-background h-4 w-2/5 mt-2?.5 mr-0 mb-1?.5 ml-2 rounded"></span>
          </div>
          <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
            <div class="animated-background h-6 w-6 my-1?.5 mr-0 ml-2 rounded-xl"></div>
            <span class="animated-background h-4 w-2/5 mt-2?.5 mr-0 mb-1?.5 ml-2 rounded"></span>
          </div>
        </div>
      </div>

      <div class="flex flex-col" class="alert-block">
        <div class="mb-2">
          <span class="animated-background h-4 w-1/3 my-1?.5 mr-0 ml-1 rounded"></span>
          <span class="font-medium text-base mb-2">Tires</span>
        </div>

        <div fxLayout="row wrap">
          <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
            <div class="animated-background h-6 w-6 my-1?.5 mr-0 ml-2 rounded-xl"></div>

            <div class="flex flex-col ml-1 w-full">
              <span class="animated-background h-4 w-1/2 my-1?.5 mr-0 ml-1 rounded"></span>
              <span class="animated-background h-4 w-1/2 my-1?.5 mr-0 ml-1 rounded"></span>
            </div>
          </div>
          <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
            <div class="animated-background h-6 w-6 my-1?.5 mr-0 ml-2 rounded-xl"></div>
            <div class="flex flex-col ml-1 w-full">
              <span class="animated-background h-4 w-1/2 my-1?.5 mr-0 ml-1 rounded"></span>
              <span class="animated-background h-4 w-1/2 my-1?.5 mr-0 ml-1 rounded"></span>
            </div>
          </div>
          <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
            <div class="animated-background h-6 w-6 my-1?.5 mr-0 ml-2 rounded-xl"></div>
            <div class="flex flex-col ml-1 w-full">
              <span class="animated-background h-4 w-1/2 my-1?.5 mr-0 ml-1 rounded"></span>
              <span class="animated-background h-4 w-1/2 my-1?.5 mr-0 ml-1 rounded"></span>
            </div>
          </div>
          <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
            <div class="animated-background h-6 w-6 my-1?.5 mr-0 ml-2 rounded-xl"></div>
            <div class="flex flex-col ml-1 w-full">
              <span class="animated-background h-4 w-1/2 my-1?.5 mr-0 ml-1 rounded"></span>
              <span class="animated-background h-4 w-1/2 my-1?.5 mr-0 ml-1 rounded"></span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col alert-block">
        <span class="font-medium text-base mb-2">XM Radio Information</span>

        <div fxLayout="row wrap">
          <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
            <div class="animated-background h-6 w-6 my-1?.5 mr-0 ml-2 rounded-xl"></div>
            <span class="animated-background h-4 w-1/2 mt-2?.5 mr-0 mb-1?.5 ml-2 rounded"></span>
          </div>
          <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
            <div class="animated-background h-6 w-6 my-1?.5 mr-0 ml-2 rounded-xl"></div>
            <span class="animated-background h-4 w-1/2 mt-2?.5 mr-0 mb-1?.5 ml-2 rounded"></span>
          </div>
        </div>
      </div>

      <div class="alert-block flex flex-col">
        <span class="font-medium text-base mb-2">Other</span>

        <div fxLayout="row wrap">
          <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
            <div class="animated-background h-6 w-6 my-1?.5 mr-0 ml-2 rounded-xl"></div>
            <span class="animated-background h-4 w-1/2 mt-2?.5 mr-0 mb-1?.5 ml-2 rounded"></span>
          </div>

          <div class="flex flex-row mb-1" fxFlex="50" fxLayoutAlign="start start">
            <div class="animated-background h-6 w-6 my-1?.5 mr-0 ml-2 rounded-xl"></div>
            <span class="animated-background h-4 w-1/2 mt-2?.5 mr-0 mb-1?.5 ml-2 rounded"></span>
          </div>
        </div>
      </div>
    </div>

    <div style="
        width: 100%;
        position: sticky;
        top: 66px;
        background: linear-gradient(0deg, rgba(255, 255, 255, 0?.7978260869565217) 0%, rgba(255, 255, 255, 1) 33%);
        z-index: 1;
        height: 56px;
      ">
      <h2>Claims History</h2>
    </div>

    <div class="py-0 px-4" id="claimsHistoryContainer">
      <div class="flex flex-col w-full result-container">
        <div fxLayoutAlign="space-between center" class="result-header-container">
          <div class="flex flex-col w-full">
            <div class="flex flex-row w-full" fxLayoutAlign="start center">
              <span class="animated-background h-5 w-2/5 mt-2?.5 mr-0 mb-1?.5 ml-2 rounded"></span>
            </div>
            <span class="animated-background h-4 w-1/3 mt-2?.5 mr-0 mb-1?.5 ml-2 rounded"></span>
          </div>
        </div>
        <mat-divider></mat-divider>
        <div class="result-content-container flex-col">
          <div class="flex flex-col">
            <div class="flex flex-col w-full">
              <div class="flex flex-row pb-5" fxLayoutAlign="start start">
                <div class="animated-background h-6 w-6 my-1?.5 mr-0 ml-2 rounded-xl"></div>
                <div class="flex flex-col">
                  <div fxLayoutAlign="start start">
                    <span class="animated-background h-4 w-4/5 mt-2?.5 mr-0 mb-1?.5 ml-2 rounded"></span>
                  </div>
                  <div class="flex flex-col">
                    <div class="flex flex-col text-grey-700">
                      <div fxLayoutAlign="start center">
                        <div class="animated-background h-1 w-1 my-1?.5 mr-0 ml-2 rounded-sm"></div>
                        <span class="animated-background h-4 w-1/2 mt-2?.5 mr-0 mb-1?.5 ml-2 rounded"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>